import "./styles/Authorization.scss"
import React from "react"
import { useNavigate } from "react-router-dom"
import Registration from "./Registration"
import Login from "./Login"

type Props = {
  isRegistration?: boolean
}

const Authorization = (props: Props) => {
  const { isRegistration } = props
  const navigate = useNavigate()

  const hundleLogin = () => {
    navigate("/login")
  }
  const hundleRegistration = () => {
    navigate("/registration")
  }

  return (
    <div className="Authorization">
      <div className="Authorization-card">
        <div className="Authorization-card-LoginSignIn">
          <div
            className={`Authorization-card-LoginSignIn-button ${isRegistration ? "active" : ""}`}
            onClick={hundleRegistration}
          >
            Зарегистрироваться
          </div>
          <div
            className={`Authorization-card-LoginSignIn-button ${!isRegistration ? "active" : ""}`}
            onClick={hundleLogin}
          >
            Войти
          </div>
        </div>
        {isRegistration ? <Registration /> : <Login />}
      </div>
    </div>
  )
}

export default Authorization
